<app-loader [Parent]="this"></app-loader>

@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Model]="Model" [Parent]="this" DeleteUrl="integrations/reliant/"
        [DeleteCheck]="false"
        DeleteNavLink="/integrations/reliant">
      </app-form-delete-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-7">
        <article class="panel">
          <p class="panel-heading">
            {{Model.Name || 'Reliant Configuration'}}
          </p>
          <a class="panel-block">
            <span class="label">URL</span>
            <span class="value">{{Model.Url}}</span>
          </a>
          <p class="panel-heading">
            {{Model.Description}}
          </p>
        </article>
      </div>
    </div>
    <!--
    TODO add way of looking at white list.
    -->
  </div>
}